export enum PAGES_ACTION_TYPES {
    SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE',
    SET_ACTIVE_SHAPE = 'SET_ACTIVE_SHAPE',
    SET_ACTIVE_SHAPE_COORDINATES = 'SET_ACTIVE_SHAPE_COORDINATES',
    TRANSLATE_ACTIVE_SHAPE = 'TRANSLATE_ACTIVE_SHAPE',
    ROTATE_ACTIVE_SHAPE = 'ROTATE_ACTIVE_SHAPE',
    SCALE_ACTIVE_SHAPE = 'SCALE_ACTIVE_SHAPE',
    STYLE_ACTIVE_SHAPE = 'STYLE_ACTIVE_SHAPE',
    ADD_PAGE = 'ADD_PAGE',
    REMOVE_PAGE = 'REMOVE_PAGE',
    ADD_SHAPE = 'ADD_SHAPE',
    SET_ACTIVE_TOOL = 'SET_ACTIVE_TOOL',
    SET_HOVERED_SHAPE = 'SET_HOVERED_SHAPE',
    TOGGLE_CONTEXT_MENU = 'TOGGLE_CONTEXT_MENU',
    CUT_SELECTED_SHAPES = 'CUT_SELECTED_SHAPES',
    COPY_SELECTED_SHAPES = 'COPY_SELECTED_SHAPES',
    PASTE_SELECTED_SHAPES = 'PASTE_SELECTED_SHAPES',
    REMOVE_SELECTED_SHAPES = 'REMOVE_SELECTED_SHAPES',
    SAVE_SELECTED_SHAPES_AS_GROUP = 'SAVE_SELECTED_SHAPES_AS_GROUP',
    SET_ACTIVE_GROUP_SHAPE = 'SET_ACTIVE_GROUP_SHPE',
    RENAME_SHAPE = 'RENAME_SHAPE',
    FORMAT_ACTIVE_SHAPE = 'FORMAT_ACTIVE_SHAPE',
    ADD_SVG_FILTERS = 'ADD_SVG_FILTERS',
    REMOVE_SVG_FILTER = 'REMOVE_SVG_FILTER',
    EDIT_SVG_FILTER = 'EDIT_SVG_FILTER',
    ADD_COLOR_IN_PALETTE = 'ADD_COLOR_IN_PALETTE',
    EDIT_PALETTE_COLOR = 'EDIT_PALETTE_COLOR',
    REMOVE_PALETTE_COLOR = 'REMOVE_PALETTE_COLOR',
    ADD_GRADIENT_IN_PALETTE = 'ADD_GRADIENT_IN_PALETTE',
    EDIT_PALETTE_GRADIENT = 'EDIT_PALETTE_GRADIENT',
    REMOVE_PALETTE_GRADIENT = 'REMOVE_PALETTE_GRADIENT',
    ADD_IMAGES_IN_PALETTE = 'ADD_IMAGES_IN_PALETTE',
    EDIT_PALETTE_IMAGES = 'EDIT_PALETTE_IMAGES',
    REMOVE_PALETTE_IMAGES = 'REMOVE_PALETTE_IMAGES',
    SAVE_FILE = 'SAVE_FILE',
    SAVE_FILE_AS = 'SAVE_FILE_AS',
    CREATE_NEW_FILE = 'CREATE_NEW_FILE',
    OPEN_A_FILE = 'OPEN_A_FILE',
    EDIT_SVG_STYLE = 'EDIT_SVG_STYLE',
    UPDATE_CURRENT_PAGE_SNAPSHOT = 'UPDATE_CURRENT_PAGE_SNAPSHOT'
};